import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import AppUrlListener from 'components/Atoms/AppUrlListener'
import Maintenance from 'components/Organisms/Maintenance'
import { getAccessToken } from 'redux-web/utils/session/actions'
import { fetchMe } from 'redux-web/utils/user/actions'

import { tokenFromCapacitor } from 'helpers/getTokenFromUrl'
import { setAccessToken } from 'redux-web/utils/session/actions'

const AppComponent = ({
  application,
  Component,
  err,
  intercom,
  loadingPage,
  pageProps,
  router,
}) => {
  const dispatch = useDispatch()
  const settingsStatus = useSelector(state => state.settings.errorStatus)
  const isMaintenanceMode = settingsStatus >= 500 && settingsStatus <= 599
  const me = useSelector(state => state.user.me)

  useEffect(() => {
    if (!me && getAccessToken()) {
      dispatch(fetchMe(null))
    }
  }, [router.pathname])

  useEffect(() => {
    if (!tokenFromCapacitor) return

    dispatch(
      setAccessToken({
        accessToken: tokenFromCapacitor,
        isGuest: false,
      })
    )

    dispatch(fetchMe())
  }, [])

  return (
    <>
      {isMaintenanceMode ? (
        <Maintenance />
      ) : (
        <>
          <AppUrlListener />
          <Component
            {...pageProps}
            err={err}
            sdk={Boolean(router?.query?.sdk)}
            loadingPage={loadingPage}
            router={router}
            intercom={intercom}
            application={application}
          />
        </>
      )}
    </>
  )
}

AppComponent.propTypes = {
  application: PropTypes.string,
  Component: PropTypes.func,
  err: PropTypes.object,
  intercom: PropTypes.object,
  loadingPage: PropTypes.bool,
  pageProps: PropTypes.object,
  router: PropTypes.object,
}

export default AppComponent
